import httpClient from '@/libs/http-client'

export function getCurrentNext () {
  const url = `/user_plan/get_current_next`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function checkBeforeDownGrade (value) {
  const url = `/user_plan/check_before_downgrade?see_more=${value}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function createPlan (planNumber) {
  const url = '/user_plan/create_plan'

  return httpClient.post(url, { planNumber }).then(response => {
    return response.data.result
  })
}

export function updatePlan (planUpdateTo, reason = {}) {
  const url = '/user_plan/update_plan'
  const params = {
    ...reason,
    planUpdateTo
  }

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function cancelChange () {
  const url = '/user_plan/cancel_change'

  return httpClient.post(url).then(response => {
    return response.data.result
  })
}

// currently not used
// export function getTerminateReasons () {
//   const url = '/user_plan/get_terminate_reasons'

//   return httpClient.get(url).then(response => {
//     return response.data.result
//   })
// }

export function useCoupon (couponNumber) {
  const url = '/user_plan/use_coupon'

  return httpClient.post(url, couponNumber).then(response => {
    return response.data.result
  })
}

export function getFirstLastDate () {
  const url = '/user_plan/get_first_last_date'

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}
